(function () {
    'use strict';
    angular.module('Services').factory('ServiceCommentTicketsTable', ServiceCommentTicketsTable);

    ServiceCommentTicketsTable.$inject = [
        'TableLiteFactory',
        'ServiceRequestTicketService',
        'toastr',
        '$filter',
        '$uibModal',
        '$location'
    ];

    function ServiceCommentTicketsTable(
        TableLiteFactory,
        ServiceRequestTicketService,
        toastr,
        $filter,
        $uibModal,
        $location
    ) {
        return function (ticketId) {
            const tableStructure = {
                tableName: 'ServiceCommentTicketsTable',
                config: {
                    noConfigureTable: true,
                    noPagination: true,
                    noHeaders: false,
                    noItemsView: true,
                    noTableFooter: true,
                    noExtraction: true,
                    noFooter:true
                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New Comment',
                        onClick: () => {
                            $uibModal.open({
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                templateUrl: '/templates/pages/service-request/modal/create-comment-modal.html',
                                controller: 'CreateCommentModalController',
                                controllerAs: 'vm',
                                keyboard: false,
                                backdrop: 'static',
                                size: 'md',
                                resolve: {
                                    ticketId: () => {
                                        return ticketId;
                                    }
                                }
                            }).result.then(res=>{
                                if(res){
                                    tableActions.sendRequest({});
                                }
                            });
                        }
                    }],
                },
                headers: [ {
                    label: 'Comments',
                    viewName: 'commentText',
                    filterName: 'commentText',
                   
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },{
                    label: 'User',
                    viewName: 'authorName',
                    filterName: 'authorName',
                    width: '150px',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Date/Time',
                    viewName: 'createdAt',
                    filterName: 'createdAt',
                    width: '135px',
                   
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }],
                data: []
            };

            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: ServiceRequestTicketService.comment,
                paramId: ticketId,
                callbackFormat: ['id','success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData();
                    toastr.error(err.message, 'Error');
                },
                defaultFilters: {
                    size: 20,
                    page: 0
                }
            });

            function buildTableData(data) {
                if (!data) { return; }
                //tableActions.initializeTableData(data);
                angular.forEach(data, (item) => {
                    item.createdAt = $filter('bbaDate')(item.createdAt);
                    item.commentText = item.commentText || 'N/A';
                    item.authorName = item.authorName || 'N/A';
                    
                    tableStructure.data.push(item);
                });
            }

            this.tableData = tableStructure;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/service-ticket-table/ServiceCommentTicketsTable.js